import { memo } from 'react'
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'

import { Image } from '../image'

const SummaryWidget = ({ title, value, icon, sx, ...other }) => {
  return (
    <Card
      sx={[
        () => ({
          p: 2,
          pl: 3,
          display: 'flex',
          alignItems: 'center'
        }),
        ...(Array.isArray(sx) ? sx : [sx])
      ]}
      {...other}
    >
      <Box sx={{ flexGrow: 1 }}>
        <Box sx={{ color: 'text.secondary', typography: 'subtitle2' }}>
          {title}
        </Box>
        <Box sx={{ my: 1.5, typography: 'h3' }}>{value}</Box>
      </Box>

      <Box
        sx={{
          width: 120,
          height: 120,
          lineHeight: 0,
          borderRadius: '50%',
          bgcolor: 'background.neutral',
          overflow: 'visible',
          position: 'relative'
        }}
      >
        <Image
          src={icon}
          sx={{
            position: 'absolute',
            top: '-15px',
            left: '-5px',
            width: '146px',
            height: '146px'
          }}
        />
      </Box>
    </Card>
  )
}

export default memo(SummaryWidget)
